module.exports = __webpack_public_path__ + "img/seed-640.9593b318.jpg";